<template>
	<div class="content">
		<div class="tableTit">
			<p class="tabtitBg"></p>
			<h6>防汛管理经费</h6>
			<el-button class="titBtn" type="primary" icon="el-icon-plus" @click="addClick()">新增</el-button>
			<!-- <el-button class="titBtn" type="success" @click="reset" icon="el-icon-refresh">重置</el-button> -->
			<!-- <el-button class="titBtn" type="success" icon="el-icon-search">搜索</el-button> -->
      <!-- <el-date-picker class="datequery"
        v-model="values"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker> -->
			<!-- <el-input class="querys" v-model.trim="dw" placeholder="输入关键字搜索"></el-input> -->
      <addressTree @obj="objdata" @close="treeClose"></addressTree>
		</div>

		<div class="tabBody">
			<el-table :data="tabledata" :height="tableHeight" @row-click="rowClick" highlight-current-row border row-key="id" :tree-props="{children: 'subList'}" :header-cell-style="{background:'rgba(49,130,222,0.1)'}">
				<el-table-column type="index" align="center" width="45" label="序号"></el-table-column>
				<el-table-column prop="ydbName" label="淤地坝名称" align="center"></el-table-column>
				<el-table-column prop="ydbFxgljfJe" label="防汛管理经费金额" align="center"></el-table-column>
				<el-table-column prop="ydbFxxzZrr" label="防汛行政责任人" align="center"></el-table-column>
        <el-table-column prop="ydbFxxzZrrLxfs" label="防汛行政责任人联系方式" align="center"></el-table-column>
        <el-table-column prop="ydbGljfFzr" label="管理经费负责人" align="center"></el-table-column>
        <el-table-column prop="ydbGljfFzrLxfs" label="管理经费负责人联系方式" align="center"></el-table-column>
				<el-table-column prop="status" label="当前状态" width="120" align="center">
          <template slot-scope="scope">
          	<p v-if="scope.row.status=='1'" class="zxfonte">未落实</p>
          	<p v-if="scope.row.status=='0'" class="zxfontb"><span class="fa fa-check fafongt"></span>已落实</p>
          </template>
        </el-table-column>
				<el-table-column prop="" label="操作" width="120" align="center">
					<template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="查看" placement="top-start">
              <el-button type="primary" class="tableedit" icon="el-icon-view" circle @click="view(scope.row,scope.$index)"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
              <el-button type="success" class="tableedit" icon="el-icon-edit" circle @click="edit(scope.row,scope.$index)"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
              <el-button type="warning" class="tableedit" icon="el-icon-delete" circle @click="deletes(scope.row,scope.$index)"></el-button>
            </el-tooltip>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<gljfpopup v-if="dialogVisible == true" :mystate="Addsid" @getcancel="Getcancel" @adddata="Adddata" @bjadddata="bjaddData"></gljfpopup>

    <div class="fye">
    	<pagintion @dsydata='DsyData' @dstdata="DstData" :ToTal='total' :pageNums="pageNums"></pagintion>
    </div>
	</div>
</template>

<script>
  import { fxgljfList, fxgljfDelete } from "@/api/api";
  import addressTree from '@/components/mangement/addressTree.vue';
	import gljfpopup from "../popup/gljfpopup.vue";
  import pagintion from '@/components/mangement/pagintion.vue';
	export default {
		data() {
			return {
        values: '',
				tabledata: [{},{}],
				tableHeight: window.innerHeight - 180,
				total: 0,
				pageSize: 20, //每页多少条数据分页
				pageNum: 1, //当前页
				pageNums: null,
				username: '',
				dw: '',
				dialogVisible: false,
				Addsid: [],
				row:null,
			}
		},
		components: {
      addressTree,
			gljfpopup,
      pagintion
		},
		mounted() {
      let params = {
      	pageSize: this.pageSize,
      	pageNum: this.pageNum,
      }
      this.list(params);
		},
		methods: {
      //调用接口获得水毁工程修复列表
      list(params) {
      	fxgljfList(params).then((res) => {
          this.tabledata = res.data;
      	})
      },
			Getcancel(data) {
				this.dialogVisible = data.dialogVisible;
			},
			Adddata(data) {
        this.dialogVisible = data.dialogVisible;
        let params={
        	pageSize: this.pageSize,
        	pageNum: this.pageNum,
        }
        this.list(params);
			},
      bjaddData(data) {
        this.dialogVisible = data.dialogVisible;
        let params={
        	pageSize: this.pageSize,
        	pageNum: this.pageNum,
        }
        this.list(params);
      },
			rowClick(row) {
				this.row = row;
			},
      addClick() {
        this.Addsid = [];
      	this.dialogVisible = true;
      	this.Addsid = ["xz"];
      },
      view(row, index) {
        this.Addsid = [];
      	this.dialogVisible = true;
      	this.Addsid = ["ck", row];
      },
			edit(row, index) {
        this.Addsid = [];
				this.dialogVisible = true;
				this.Addsid = ["bj", row];
			},
			reset(){
        this.dw = '';
			},
			deletes(row, index) {
      	this.$confirm('确定删除当前用户吗?此操作将永久删除, 是否继续?', '提示', {
      		confirmButtonText: '确定',
      		cancelButtonText: '取消',
      		type: 'warning'
      	}).then(action => {
      		if(action === 'confirm') {
            let ids = [];
            ids.push(row.id);
      			fxgljfDelete(ids).then((res) => {
      				if(res.code == 200) {
      					this.$notify({
      						title: "提示",
      						message: res.message,
      						type: "success",
      					});
      					let params = {
      						pageSize: this.pageSize,
      						pageNum: this.pageNum,
      					}
      					this.list(params)
      				} else {
      					this.$notify({
      						title: "提示",
      						message: res.message,
      						type: "success",
      					});
      				}
      			})
      		}
      	}).catch(() => {
      		this.$message({
      			message: '已取消',
      			type: 'warning'
      		});
      	});
      },
      treeClose() {
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        }
        this.list(params)
      },
      objdata(data) {
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          ydbCode: data.ydbCode
        }
        this.list(params)
      },
      DsyData(data) { //多少页
      	this.pageNum = data.dsy;
      	let params = {
      		pageSize: this.pageSize,
      		pageNum: this.pageNum,
      	}
      	this.list(params)
      },
      DstData(data) { //多少条
      	this.pageSize = data.dst;
      	let params = {
      		pageSize: this.pageSize,
      		pageNum: this.pageNum,
      	}
      	this.list(params)
      },
		}
	}
</script>

<style scoped>
	@import url('../../../common/css/mangementall.css');
  .datequery {
    height: 30px;
    float: right;
    width: 230px;
    margin-top: 10px;
    margin-right: 10px;
  }

  >>>.el-range-separator {
    margin-bottom: 8px;
  }

  >>>.el-date-editor .el-range__icon {
    margin-bottom: 8px;
  }

	.querys {
		height: 30px;
		float: right;
		width: 200px;
		margin-top: 10px;
		margin-right: 10px;
	}

	>>>.el-input__inner {
		height: 30px;
		line-height: 30px;
		color: #606266;
		padding-left: 10px;
		font-size: 14px;
	}
</style>
